module.exports = __webpack_public_path__ + "img/JobSeeker.892380c3.svg";